import type { ComputedRef } from 'vue';

export type InternalNavigationBarProvide = {
	addLinkToObserved: (link: string) => void;
	activeLink: ComputedRef<string | undefined>;
};

export const NavigationBarProvideKey = 'InternalNavigationBarProvide' as const;
